import { render, staticRenderFns } from "./CustomerAnalytics.vue?vue&type=template&id=08c06726"
import script from "./CustomerAnalytics.vue?vue&type=script&lang=js"
export * from "./CustomerAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports